import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Image, Modal, Table, Tooltip } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import MerchantLayout from "../../layout/MerchantLayout";
import { NotificationInfo, UserInfo } from "../../../context";
import AddBanner from "./AddBanner";

const MerchantBanner = () => {
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const [deleteDrawer, setDeleteDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [bannerList, setBannerList] = useState({
    data: [],
    ready: false,
  });
  const [confirmLoading, setConfirmLoading] = useState(false);

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      render: (date) => (
        // <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
        <p>{moment.utc(new Date(date)).format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Banner Image",
      dataIndex: "banner",
      render: (text, record) => (
        <Image
          width={150}
          height={"auto"}
          src={`${import.meta.env.VITE_API_IMAGE}banner/${text}`}
          placeholder={"logo"}
          preview={true}
          alt="banner-img"
        />
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDrawer(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getBannerList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/banner-list", { params })
      .then((response) => {
        const data = response.data;
        setBannerList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getBannerList();
  }, [getBannerList]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDrawer(false);
      setConfirmLoading(false);
      handleDeleteBanner();
    }, 2000);
  };

  const handleDeleteBanner = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    formdata.append(
      "old_banner",
      selectedData !== null ? selectedData.banner : ""
    );
    setLoading(true);
    axios
      .post("user/merchant/delete-banner", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Banner is delete successfully.");
          setTimeout(() => {
            setLoading(false);
            getBannerList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <MerchantLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
        >
          Add Banner
        </Button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={bannerList.data.length > 0 ? bannerList.data : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <AddBanner
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          rerun={() => getBannerList()}
        />
      )}

      <Modal
        title="Are you sure to delete this banner?"
        open={deleteDrawer}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDrawer(false)}
        centered
      />

      {/* {deleteDrawer && (
        <EditDineType
          open={deleteDrawer}
          close={() => setDeleteDrawer(false)}
          setLoading={setLoading}
          rerun={() => getBannerList()}
          selectedData={selectedData}
        />
      )} */}
    </MerchantLayout>
  );
};

export default MerchantBanner;
